import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderAddDeleteButton,
  renderAdditionalComments,
  renderFile,
  renderEffectiveDate,
  renderMoney,
} from "./RenderUtils";

export class AddDeleteWaiverOfSubrogationRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          {renderAddDeleteButton(
            "Add/Delete Waiver of Subrogation",
            request,
            updateRequest
          )}
          {renderTextBox(
            "nameOfWaiverOfSubrogationHolder",
            "Name of waiver of subrogation holder",
            request,
            updateRequest
          )}
          {renderTextBox(
            "nameOfProject",
            "Name of project",
            request,
            updateRequest
          )}
          {renderMoney(
            "valueOfProject",
            "Value of project",
            request,
            updateRequest
          )}
          {renderTextBox("reason", "Reason", request, updateRequest)}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
